















































































































































































































































































































import { Vue } from 'vue-property-decorator'
import SparePartsTable from './SparePartsTable.vue'
import dayjs from 'dayjs'
import moment from 'moment'
import AppUploadImg from '@/components/AppUploadImg/index.vue'
import { DeviceServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import {
  RepairApplyServiceProxy,
  MalfunctionTypeServiceProxy
} from '@/service-proxies/app-v2/tpm.service-proxies'
import { EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { getImg, formatTimeSlot, getTxt } from '@/utils'
import previewImg from '@/components/PreviewImg/index.vue'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { cloneDeep } from 'lodash'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
import { getLocalStorage } from '@/utils/storage'
import { StockOutOrderMaterialServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'

const resourceService = new ResourceServiceProxy()
const soomsp = new StockOutOrderMaterialServiceProxy()
const dsp = new DeviceServiceProxy()
const rasp = new RepairApplyServiceProxy()
const esp = new EmployeeServiceProxy()
const mtsp = new MalfunctionTypeServiceProxy()
const csp = new CodeRuleServiceProxy()
export default Vue.extend({
  name: 'AddOrEditForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    deviceTypeId: {
      type: String,
      default: ''
    },
    editData: {
      type: Object
    },
    apply: {
      type: Object
    }
  },
  components: { SparePartsTable, AppUploadImg, previewImg },
  data() {
    return {
      trueMalfunctionTime: false,
      shows: true,
      show: false,
      repairCodeIdList: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        recordTypeName: '',
        recordType: undefined,
        recordCode: '',
        repairApplyId: undefined,
        deviceCode: undefined,
        deviceName: '',
        deviceTypeName: '',
        deviceTypeId: '',
        deviceId: '',
        codeRuleId: '',
        standardModel: '',
        malfunctionTime: null,
        isAffect: undefined,
        repairUserId: undefined,
        repairStartTime: null,
        repairEndTime: null,
        repairTime: '',
        malfunctionDetails: '',
        recordFileList: [],
        fileAddDTOList: [],
        // applyUserName: '', // 维修申请人
        // urgency: '', // 紧急度
        // applyTime: '', // 申请时间
        errorCode: '', // 故障码
        malfunctionId: undefined, // 故障类型id
        malfunctionCode: '',
        malfunctionName: ''
      },
      formDeviceInfo: {},
      repairUserInfo: {},
      deviceList: [],
      filterDeviceList: [],
      employeeList: [],
      repairApplyList: [], // 申请单列表
      loading: false,
      fileList: [], // 上传附件列表
      imgList: [], // 维修申请图片列表
      repairApplyDetailVo: {
        fileAddDTOList: []
      }, // 申请单相关信息
      tableData: [],
      formatTimeSlot,
      defaultList: [],
      previewVisible: false,
      previewIndex: 0,
      listInfo: [],
      encode: 'UTF-8',
      list: [],
      malfunctionList: []
    }
  },
  computed: {
    recordTypeList() {
      return [
        { label: this.$t('page_tpm_repair_temporary_repairs'), value: 1 },
        { label: this.$t('page_tpm_repair_routine_maintenance'), value: 2 }
      ]
    },
    isAffectList() {
      return [
        { label: this.$t('yes'), value: 1 },
        { label: this.$t('no'), value: 2 }
      ]
    },
    rules() {
      return {
        // 维修记录类型
        recordType: [
          {
            required: true,
            message: this.$t('page_tpm_repair_select_record_type'),
            trigger: 'blur'
          }
        ],
        //发生时间
        malfunctionTime: [
          {
            required: this.trueMalfunctionTime,
            message: this.$t('page_tpm_repair_select_occurrence_time'),
            trigger: 'change'
          }
        ],
        //开始时间
        repairStartTime: [
          {
            required: this.trueMalfunctionTime,
            message: this.$t('page_tpm_repair_select_start_time'),
            trigger: 'change'
          }
        ],
        //
        repairEndTime: [
          {
            required: this.trueMalfunctionTime,
            message: this.$t('page_tpm_repair_select_end_time'),
            trigger: 'change'
          }
        ],
        // 维修单号
        recordCode: [
          {
            max: 48,
            message: this.$t('page_material_warehousing_custom_more48'),
            trigger: 'change'
          }
        ],
        // 申请单号
        repairApplyId: [
          {
            required: true,
            message: this.$t('page_tpm_repair_select_apply_code'),
            trigger: 'blur'
          }
        ],
        // 设备编码
        deviceCode: [
          {
            required: !(this.form.recordType === 2),
            message: this.$t('page_tpm_repair_select_device_code'),
            trigger: 'blur'
          }
        ],
        // 故障分析
        malfunctionDetails: [
          {
            max: 100,
            message: this.$t('page_material_warehousing_custom_more100'),
            trigger: 'blur'
          }
        ]
      }
    },
    repairTime() {
      // 维修用时
      if (this.form.repairEndTime && this.form.repairStartTime) {
        return dayjs(this.form.repairEndTime).diff(dayjs(this.form.repairStartTime), 'minute')
      } else {
        return null
      }
    }
  },
  watch: {
    type: {
      handler(val) {
        if (val === 'edit') {
          this.shows = false
        }
      },
      immediate: true
    },
    visible: {
      handler(val) {
        if (val) {
          this.imgList = []
          this.getDeviceList()
          this.getEmployeeList()
          this.getApplyCodeList()
          this.getCodeAndRecord()
          if (val && this.type === 'add') {
            this.form.repairEndTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          }
        }
      },
      immediate: true
    },
    editData: {
      handler(val) {
        this.defaultList = []
        if (val) {
          Object.assign(this.form, val)
          // console.log('form data:', val)
          if (this.form.repairApplyDetailVo) {
            if (this.form.repairApplyDetailVo.malfunctionTime) {
              this.form.malfunctionTime = this.form.repairApplyDetailVo.malfunctionTime
                ? moment(this.form.repairApplyDetailVo.malfunctionTime, 'YYYY-MM-DD HH:mm:ss')
                : null
            }
            if (this.form.repairApplyDetailVo.repairUserId) {
              this.form.repairUserId = this.form.repairApplyDetailVo.repairUserId
            }
            if (this.form.repairApplyDetailVo.isAffect) {
              this.form.isAffect = this.form.repairApplyDetailVo.isAffect
            }
            if (this.form.repairApplyDetailVo.isAffectStr) {
              this.form.isAffectStr = this.form.repairApplyDetailVo.isAffectStr
            }
          }
          this.form.repairStartTime = this.form.repairStartTime
            ? moment(this.form.repairStartTime, 'YYYY-MM-DD HH:mm:ss')
            : null
          this.form.repairEndTime = this.form.repairEndTime
            ? moment(this.form.repairEndTime, 'YYYY-MM-DD HH:mm:ss')
            : null
          if (this.form.repairApplyDetailVo) {
            let {
              applyUserName,
              urgencyStr,
              applyTime,
              fileAddDTOList,
              applyCode
            } = this.form.repairApplyDetailVo
            Object.assign(this.repairApplyDetailVo, {
              applyUserName,
              urgencyStr,
              applyTime,
              fileAddDTOList,
              applyCode
            })
          }
          this.tableData = this.form.materialVOList
          this.defaultList = val.recordFileAddDTOList
        }
      },
      deep: true,
      immediate: true
    },
    'repairApplyDetailVo.fileAddDTOList': {
      handler(val) {
        this.imgList = []
        this.listInfo = []
        if (val && val.length) {
          this.list = val
          this.getListInfo()
          // val.map(async (file) => {
          //   let content = await getImg(file);
          //   this.imgList.push(content);
          //   return content;
          // });
        }
      },
      deep: true
    },
    'form.recordType': {
      handler(val) {
        if (this.type !== 'add') {
          this.shows = false
          return
        }
        let init1 = {
          deviceCode: undefined,
          deviceName: '',
          deviceTypeName: '',
          deviceTypeId: '',
          deviceId: ''
        }
        if (val == 1) {
          // 临时维修
          let init = {
            malfunctionId: undefined,
            malfunctionName: '',
            malfunctionCode: '',
            malfunctionTime: null,
            repairApplyId: undefined,
            repairUserId: undefined,
            repairUserName: '',
            isAffect: undefined,
            isAffectStr: ''
          }
          Object.assign(this.form, init1, init)
          this.repairApplyDetailVo = {
            fileAddDTOList: []
          }
          this.imgList = []
        }
      },
      deep: true
    },
    'editData.deviceId': {
      handler(val) {
        if (val) {
          this.changeDevice(val)
        }
      },
      deep: true,
      immediate: true
    },
    repairTime: {
      handler(val) {
        this.form.repairTime = val
      },
      immediate: true
    },
    fileList: {
      handler(val) {
        if (val) {
          let temp = val.map((item) => ({
            contentType: item.contentType,
            fileName: item.originalFilename || item.filename,
            objectKey: item.objectKey
          }))
          this.form.recordFileList = [...temp]
        }
      },
      deep: true
    },
    'apply.applyId': {
      handler(val) {
        console.log(this.apply.applyId, 66665)
        if (val) {
          console.log(22323)
          this.form.recordType = 2
          this.form.repairApplyId = this.apply.applyId
          this.getApplyDetail()
          this.$nextTick(() => {
            this.getReadyApplyItem(this.apply.applyId)
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    csp.list('RepairRecordObject').then((res) => {
      this.repairCodeIdList = res
    })
  },
  methods: {
    // 获取故障码列表
    async getCodeAndRecord() {
      this.malfunctionList = []
      this.malfunctionList = await mtsp.getCodeAndRecord()
    },
    // 获取设备列表
    async getDeviceList() {
      let params: any = {
        deviceTypeId: this.deviceTypeId,
        filter: '',
        tenantId: getLocalStorage('USER_INFO').tenant_id
      }
      let list = await dsp.getPageDevices(1, params, -1)
      this.deviceList = list.records
      this.filterDeviceList = this.deviceList.map((item) => ({
        label: item.code,
        value: item.id
      }))
    },
    // 获取维修人员列表
    async getEmployeeList() {
      let params: any = { statusList: [1] }
      const data = await esp.getEmployeeList(params)
      this.employeeList = data.map((item) => ({
        label: item.name,
        value: item.id
      }))
    },
    // 获取维修申请单号列表(维修记录类型为'例行维修'时才有)
    async getApplyCodeList() {
      try {
        let res = await rasp.getApplyCodeList()
        this.repairApplyList = res.map((item) => ({
          label: item.applyCode,
          value: item.id
        }))
      } catch (e) {}
    },
    changeRuleRepair(val) {
      this.form.codeRuleId = val
      if (val) {
        this.form.recordCode = ''
        this.show = true
        this.trueMalfunctionTime = true
      } else {
        this.show = false
        this.trueMalfunctionTime = false
        this.$refs.ruleForm.clearValidate(['malfunctionTime', 'repairEndTime', 'repairStartTime'])
      }
    },
    async getReadyApplyItem(val) {
      let res = await rasp.getApplyCodeList()
      if (res && res.length) {
        const repair = res.find((res) => res.id === val)
        if (repair) {
          soomsp
            .getStockOutOrderMaterialListByTpmCodeAndTpmId(repair.applyCode, repair.id)
            .then((res) => {
              this.tableData = res
            })
        }
      }
    },
    // 改变维修记录类型
    changeRepairApplyId(val) {
      console.log(val, 6669859)
      if (val) {
        this.getApplyDetail()
        const repair = this.repairApplyList.find((res) => res.value === val)
        if (repair) {
          soomsp
            .getStockOutOrderMaterialListByTpmCodeAndTpmId(repair.label, repair.value)
            .then((res) => {
              this.tableData = res
            })
        }
      }
    },
    changeRepairRecord(val) {
      if (val === 2) {
        this.form.recordTypeName = '例行维修'
      } else {
        this.form.recordTypeName = '临时维修'
      }
    },
    // 改变故障类型
    changeMalfunction(val) {
      let { name, code } = this.malfunctionList.find((item) => item.id === val)
      let malFunctionInfo = {
        malfunctionCode: code,
        malfunctionName: name
      }
      Object.assign(this.form, malFunctionInfo)
    },
    // 选择设备编码
    changeDevice(val) {
      this.deviceList.map((item) => {
        if (item.id === val) {
          this.formDeviceInfo = {
            deviceId: item.id,
            deviceCode: item.code,
            deviceTypeId: item.deviceTypeId,
            deviceTypeName: item.deviceTypeName,
            deviceName: item.name,
            standardModel: item.standardModel
          }
          Object.assign(this.form, this.formDeviceInfo)
        }
      })
    },
    // 选择维修人员
    changeRepairUser(val) {
      const { value, label } = this.employeeList.find((item) => item.value === val)
      this.repairUserInfo = {
        repairUserId: value,
        repairUserName: label
      }
      Object.assign(this.form, this.repairUserInfo)
    },
    // 获取维修申请详情(包含对应附件)
    async getApplyDetail() {
      let res = await rasp.getApplyDetail(this.form.repairApplyId)
      Object.assign(this.form, res)
      this.form.repairStartTime = res.startTime
        ? dayjs(res.startTime).format('YYYY-MM-DD HH:mm:ss')
        : null
      this.form.repairEndTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      Object.assign(this.repairApplyDetailVo, res)
      // console.log('repairApplyDetailVo:', this.repairApplyDetailVo)
    },
    getAllData() {
      return new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid, data) => {
          if (valid) {
            // 校验通过
            let materialAddDTOList = this.$refs.sparePartsTable.getList()
            this.form.malfunctionTime = this.form.malfunctionTime
              ? dayjs(this.form.malfunctionTime).format('YYYY-MM-DD HH:mm:ss')
              : ''
            this.form.repairStartTime = this.form.repairStartTime
              ? dayjs(this.form.repairStartTime).format('YYYY-MM-DD HH:mm:ss')
              : ''
            this.form.repairEndTime = this.form.repairEndTime
              ? dayjs(this.form.repairEndTime).format('YYYY-MM-DD HH:mm:ss')
              : ''
            let temp = Object.assign({}, this.form, { materialAddDTOList })
            resolve(temp)
          } else {
            resolve(valid)
          }
        })
      })
    },
    openPreview(i, arr) {
      this.previewVisible = true
      this.previewIndex = i
    },
    closePreview() {
      this.previewVisible = false
    },
    getListInfo() {
      this.list.map(async (file, index) => {
        let content

        if (
          file.contentType != 'image/jpg' &&
          file.contentType != 'image/jpeg' &&
          file.contentType != 'image/png' &&
          file.contentType != 'image/svg' &&
          file.contentType != 'image/gif' &&
          file.contentType != 'text/txt' &&
          file.contentType != 'text/json' &&
          file.contentType != 'application/pdf' &&
          file.contentType != 'application/swf' &&
          file.contentType != 'image/octet-stream'
        ) {
          file.contentType = 'text/txt'
          content = await getTxt(file, this.encode)
        }

        if (file.contentType.indexOf('image') > -1) {
          content = await getImg(file)
        }

        if (file.contentType.indexOf('pdf') > -1) {
          content = await (await resourceService.statFileUsingGET(file.objectKey)).data.link
        }

        let temp = {
          type: file.contentType.substring(0, file.contentType.indexOf('/')),
          content
        }
        this.listInfo[index] = temp
        this.listInfo = cloneDeep(this.listInfo)
        // console.log("qqqqqqqqqq:", this.listInfo);
      })
    },
    changeEncode(val) {
      this.encode = val
      this.getListInfo()
    }
  }
})
